import { cn } from '~/shared/lib/utils'

interface SegmentedControlProps<T extends string> {
  /** Read out for the whole group; not shown. */
  label: string
  value: T
  options: readonly { value: T; label: string }[]
  onChange: (value: T) => void
  size?: 'default' | 'sm'
}

export function SegmentedControl<T extends string>({
  label,
  value,
  options,
  onChange,
  size = 'default',
}: SegmentedControlProps<T>) {
  return (
    <fieldset
      className={cn(
        'inline-flex items-center rounded-lg border bg-muted',
        size === 'sm' ? 'shrink-0 gap-0.5 p-0.5' : 'flex-wrap gap-1 p-1',
      )}
    >
      <legend className="sr-only">{label}</legend>
      {options.map((option) => {
        const selected = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              'rounded-md text-xs transition-colors whitespace-nowrap',
              size === 'sm' ? 'px-2 py-1' : 'px-3 py-1.5 sm:text-sm',
              'motion-reduce:transition-none',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              selected
                ? 'bg-background font-medium text-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {option.label}
          </button>
        )
      })}
    </fieldset>
  )
}
